import { z } from "zod";
import i18n from "../../../strings/i18n";
var MAX_LENGTH = 26;
// Regex to only accepts digits, letters and spaces up to 26 chars.
var ALLOWED_REGEX = /^[A-Za-z0-9 ]{0,26}$/;
var inputSchema = z.string().superRefine(function (val, ctx) {
    // Check max length
    if (val.length > MAX_LENGTH) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "".concat(val.length, "/").concat(MAX_LENGTH),
        });
    }
    // Check allowed characters (no special chars)
    if (!ALLOWED_REGEX.test(val)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n({ labels: "loanNickNameAllowedChars" }),
        });
    }
    // Count numbers in the string
    var numCount = (val.match(/\d/g) || []).length;
    if (numCount > 4) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n({ labels: "loanNickNameNumCountError" }),
        });
    }
});
export default inputSchema;
//# sourceMappingURL=LoanNickNameSchema.js.map